interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "dark",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`reveal ${isCenter ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}`}>
      <span
        className={`inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.15em] ${
          tone === "dark" ? "text-primary-600" : "text-accent-400"
        }`}
      >
        <span
          className={`w-6 h-px ${tone === "dark" ? "bg-primary-500" : "bg-accent-400"}`}
        ></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-3 md:mt-4 font-heading text-2xl md:text-4xl font-bold leading-snug ${
          tone === "dark" ? "text-foreground-950" : "text-background-50"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 md:mt-4 text-sm md:text-base leading-relaxed ${
            tone === "dark" ? "text-foreground-600" : "text-background-200"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}